import axios from 'axios';
import moment from 'moment';

export default {
  namespaced: true,

  state: {
    reproachesLessons: [],
    reproachesLessonsAllStudents: [],
    campusesForSelect: [],
    teachers: [],
    lessons: [],
    lessonsSlots: [],
    students: [],
    campus: [],
    campusSettings: null,
    newSlots: [],
    loading: 1,
    slotsAllCampusStudent: [],
    editCal: {
      title: true,
      drag: true,
      resize: true,
      create: true,
      delete: true
    },
    canEdit: true
  },

  getters: {
    getCampusesForSelect(state) {
      return state.campusesForSelect;
    },
    GET_CAMPUS_STUDENTS: state => state.students,
    GET_CAMPUS_TEACHERS: state => state.teachers,
    GET_CAMPUS_LESSONS: state => state.lessons,
    GET_CAMPUS: state => state.campus,
    GET_CAMPUS_SETTINGS: state => state.campusSettings,
    GET_CAMPUS_LESSONS_SLOTS: state => state.lessonsSlots,
    GET_CAMPUS_LOADING: state => state.loading,
    GET_CAMPUS_CAN_EDIT: state => state.canEdit,
    GET_CAMPUS_EDIT_CAL: state => state.editCal
  },

  mutations: {
    SET_REPROACHES_LESSONS(state, value) {
      state.reproachesLessons = value;
    },
    SET_ALL_CAMPUS_STUDENT(state, value) {
      console.log(value, 'value');
      state.slotsAllCampusStudent = value;
    },
    SET_REPROACHES_LESSONS_ALL_STUDENTS(state, value) {
      state.reproachesLessonsAllStudents = value;
    },
    SET_CAMPUSES_FOR_SELECT(state, value) {
      state.campusesForSelect = value;
    },
    CHANGE_CAMPUS_TEACHERS(state, value) {
      state.teachers = value;
    },
    CHANGE_CAMPUS_LESSONS(state, value) {
      state.lessons = value;
    },
    CHANGE_FETCH_STUDENTS(state, value) {
      state.students = value;
    },
    CHANGE_CAMPUS(state, value) {
      state.campus = value;
    },
    CHANGE_CAMPUS_LOADING(state) {
      state.loading++;
    },
    CHANGE_CAMPUS_CAN_EDIT(state, value) {
      state.canEdit = value;
    },
    CHANGE_CAMPUS_EDIT_CAL(state, value) {
      state.editCal.drag = value;
      state.editCal.resize = value;
      state.editCal.create = value;
      state.editCal.delete = value;
      state.editCal.title = value;
    },
    CHANGE_CAMPUS_EDIT_CAL_LESSONS(state, value) {
      state.lessons.forEach(item => {
        item.resizable = value;
      });
    },
    CHANGE_ADD_LESSON(state, lesson) {
      state.lessons.push(lesson);
    },
    UPDATE_LESSON(state, [id, lesson]) {
      state.lessons[id] = lesson;
    },
    CHANGE_NEW_SLOTS(state) {
      state.newSlots = [];
    },
    DELETE_LESSON(state, index) {
      if (index > -1) {
        state.lessons.splice(index, 1);
      }
    },
    CHANGE_CAMPUS_SETTINGS(state, settings) {
      state.campusSettings = settings;
    }
  },

  actions: {
    async fetchReproachesLessons({ commit }, settings) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.reproachesSchedule,
        {
          params: { ...settings }
        }
      );
      const lessons = res.data.data;
      commit('SET_REPROACHES_LESSONS', lessons);
    },
    async fetchReproachesLessonsAllStudents({ commit }, settings) {
      // const qs = require('qs');
      const res = await this.$service.retrieve(
        this.$services.studyCenter.reproachesScheduleAllStudent,
        {
          params: { ...settings }
          // paramsSerializer(params) {
          //   return qs.stringify(params, { arrayFormat: 'repeat' });
          // }
        }
      );
      const lessons = res.data.data;
      commit('SET_REPROACHES_LESSONS_ALL_STUDENTS', lessons);
    },
    async fetchReproachesLessonsAllStudentsNew({ commit }, settings) {
      // const qs = require('qs');
      // console.log(settings, 'settings');
      // co
      // const res = await this.$service.create(
      //   this.$services.studyCenter.reproachesScheduleAllStudentNew,
      //   {
      //     ...settings
      //     // paramsSerializer(params) {
      //     //   return qs.stringify(params, { arrayFormat: 'repeat' });
      //     // }
      //   }
      // );
      const res = await axios.post(
        '/api/main-info/combined-schedule/get-meetings',
        settings
      );
      const lessons = res.data.data;
      commit('SET_REPROACHES_LESSONS_ALL_STUDENTS', lessons);
    },

    getCampusesForSelectData({ commit }) {
      axios.get('/api/campuses').then(res => {
        const campuses = res.data.data;
        commit('SET_CAMPUSES_FOR_SELECT', campuses);
      });
    },
    GET_CAMPUS_CAN_EDIT({ state, commit }) {
      const flag = !state.canEdit;
      commit('CHANGE_CAMPUS_CAN_EDIT', flag);
      commit('CHANGE_CAMPUS_EDIT_CAL', flag);
      commit('CHANGE_CAMPUS_EDIT_CAL_LESSONS', flag);
      commit('CHANGE_CAMPUS_LOADING');
    },
    GET_CAMPUS_EDIT_CAL({ state, commit }) {
      commit('CHANGE_CAMPUS_EDIT_CAL', state.canEdit);
    },
    async GET_FETCH_STUDENTS({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studentList.students,
        {
          params
        }
      );
      const students = res.data.data.map(s => ({
        ...s.user,
        id: s.user.id,
        user_id: s.user.id,
        student_id: s.id,
        class_name: s.student_class?.class_name,
        group_name: s.group?.name
      }));
      commit('CHANGE_FETCH_STUDENTS', students);
    },
    GET_CAMPUS_LOADING({ commit }) {
      commit('CHANGE_CAMPUS_LOADING');
    },
    SET_NEW_SLOTS({ commit }) {
      commit('CHANGE_NEW_SLOTS');
    },
    SET_ADD_LESSON({ commit, state }, lesson) {
      const start = moment(lesson.start).format('HH:mm'),
        finish = moment(lesson.end).format('HH:mm'),
        time = start + '-' + finish;

      lesson.slot = {
        start,
        finish,
        time
      };
      lesson.day = {
        weekday: moment(lesson.start).day()
      };
      lesson.teacher_id = lesson.split;

      const teacher = state.teachers.find(item => item.id === +lesson.split);
      if (teacher) {
        lesson.teacher = teacher;
      }
      commit('CHANGE_ADD_LESSON', lesson);
    },
    SET_CAMPUS_SETTINGS({ commit }, form = null) {
      let settings = null;
      if (form) {
        const startValue = form.start.value.split(':');
        const endValue = form.end.value.split(':');
        settings = {
          start: {
            HH: startValue[0],
            mm: startValue[1],
            value: form.start.value
          },
          end: {
            HH: endValue[0],
            mm: endValue[1],
            value: form.end.value
          },
          step: form.step
        };
        localStorage.setItem('settingsStartHH', +startValue[0]);
        localStorage.setItem('settingsStartmm', +startValue[1]);
        localStorage.setItem('settingsEndHH', +endValue[0]);
        localStorage.setItem('settingsEndmm', +endValue[1]);
        localStorage.setItem('settingsStep', form.step);
      }
      const startHH = +localStorage.getItem('settingsStartHH') || 7;
      const startmm = +localStorage.getItem('settingsStartmm') || 0;
      const endHH = +localStorage.getItem('settingsEndHH') || 23;
      const endmm = +localStorage.getItem('settingsEndmm') || 0;
      let startValue = null;
      let endValue = null;
      if (startmm < 10) {
        startValue = startHH + ':' + '0' + startmm;
      } else {
        startValue = startHH + ':' + startmm;
      }
      if (endmm < 10) {
        endValue = endHH + ':' + '0' + endmm;
      } else {
        endValue = endHH + ':' + endmm;
      }
      settings = {
        start: {
          HH: startHH,
          mm: startmm,
          value: startValue
        },
        end: {
          HH: endHH,
          mm: endmm,
          value: endValue
        },
        step: +localStorage.getItem('settingsStep') || 20
      };
      commit('CHANGE_CAMPUS_SETTINGS', settings);
    },
    async GET_CAMPUS_LESSONS_LIST({ commit, dispatch, state }, params) {
      if (params.category_url) {
        const dateDay = params.day;
        await dispatch('studyCenter/fetchExceptionDays', params, {
          root: true
        });
        await dispatch('studyCenter/fetchClassLevels', params, {
          root: true
        });
        await axios
          .get('/api/study-center/day-lessons', {
            params
          })
          .then(res => {
            commit('studyCenter/SET_DAYS', res.data, { root: true });
            const teachers = res.data.teachers;
            const day = res.data;
            commit('CHANGE_CAMPUS_TEACHERS', teachers);
            const slots = [];

            const lessons = [];

            teachers.forEach(t => {
              const date = new Date(dateDay);
              for (const slot of day.slots) {
                if (slot) {
                  const result = {
                    day,
                    date,
                    dateShort: dateDay,
                    teacher: t,
                    split: t.id,
                    start: dateDay + ' ' + slot.start.substr(0, 5),
                    end: dateDay + ' ' + slot.finish.substr(0, 5),
                    resizable: false,
                    deletable: false,
                    slot,
                    type_id: slot.type_id,
                    disabled: false,
                    free: false,
                    background: true
                  };
                  result.slot.time =
                    slot.start.substr(0, 5) + '-' + slot.finish.substr(0, 5);
                  if (result.scheduleLesson) {
                    result.disabled = !result.scheduleLesson.is_active;
                  }

                  if (result.lesson) {
                    result.disabled = !result.lesson.is_active;
                  }
                  if (!result.lesson && !result.scheduleLesson) {
                    result.free = true;
                  }
                  if (slot.type_id === 1) {
                    slots.push(result);
                  }
                }
              }
              t.lessons.forEach(l => {
                const index = t.study_center_skills.findIndex(
                  sk => sk.id === l.teacher_skill_id
                );
                if (l) {
                  l.start_time = l.start;
                  delete l.start;
                  if (l.start_time && l.finish) {
                    lessons.push({
                      skill_name: t.study_center_skills[index]
                        ? t.study_center_skills[index].name
                        : null,
                      split: l.teacher_id,
                      start:
                        l.date.substr(0, 10) + ' ' + l.start_time.substr(0, 5),
                      end: l.date.substr(0, 10) + ' ' + l.finish.substr(0, 5),
                      resizable: true,
                      ...l
                    });
                  }
                }
              });
            });
            lessons.forEach((lesson, ind) => {
              const index = slots.findIndex(
                slot => slot.teacher.id === lesson.teacher_id
              );
              const start = index;
              const length = start + slots.length;
              let flag = true;
              for (let i = start; i < length; i++) {
                if (
                  (slots[i] &&
                    slots[i].slot &&
                    slots[i].slot.start === lesson.start_time &&
                    slots[i].teacher.id === lesson.teacher_id) ||
                  (slots[i] &&
                    slots[i].slot &&
                    slots[i].slot.start > lesson.start_time &&
                    lesson.finish > slots[i].slot.start &&
                    slots[i].teacher.id === lesson.teacher_id) ||
                  (slots[i] &&
                    slots[i].slot &&
                    slots[i].slot.finish > lesson.start_time &&
                    lesson.finish > slots[i].slot.finish &&
                    slots[i].teacher.id === lesson.teacher_id)
                ) {
                  if (!slots[i].lesson && !lesson.flag) {
                    lesson.flag = true;
                    slots[i].lesson = lesson;
                    slots[i].background = false;
                    slots[i].start = lesson.start;
                    slots[i].finish = lesson.finish;
                    slots[i].end = lesson.end;
                    slots[i].deletable = true;
                    slots[i].resizable = true;

                    flag = false;
                  }
                }
              }
              if (flag) {
                const slot = {
                  ...lesson,
                  resizable: true,
                  lesson
                };
                const teacher = state.teachers.find(
                  item => item.id === +lesson.split
                );
                if (teacher) {
                  slot.teacher = teacher;
                }
                slots.push(slot);
              }
            });
            commit('CHANGE_CAMPUS', day);
            commit('CHANGE_CAMPUS_LESSONS', slots);
            commit('CHANGE_CAMPUS_LOADING');
          });
      }
    },
    async GET_CAMPUS_LESSONS_LIST_WEEK({ commit, dispatch, state }, params) {
      if (params.category_url) {
        await axios
          .get('/api/study-center/week-lessons', {
            params
          })
          .then(({ data: days }) => {
            const slots = [];
            const lessons = [];
            Object.entries(days).forEach(([key, value]) => {
              const dateDay = key;
              const teachers = value.teachers;
              const day = value;
              commit('CHANGE_CAMPUS_TEACHERS', teachers);
              teachers.forEach(t => {
                const date = new Date(dateDay);
                for (const slot of day.slots) {
                  if (slot) {
                    const result = {
                      day,
                      date,
                      dateShort: dateDay,
                      teacher: t,
                      split: t.id,
                      start: dateDay + ' ' + slot.start.substr(0, 5),
                      end: dateDay + ' ' + slot.finish.substr(0, 5),
                      resizable: true,
                      slot,
                      type_id: slot.type_id,
                      disabled: false,
                      free: false
                    };
                    result.slot.time =
                      slot.start.substr(0, 5) + '-' + slot.finish.substr(0, 5);
                    if (result.scheduleLesson) {
                      result.disabled = !result.scheduleLesson.is_active;
                    }

                    if (result.lesson) {
                      result.disabled = !result.lesson.is_active;
                    }
                    if (!result.lesson && !result.scheduleLesson) {
                      result.free = true;
                    }
                    if (slot.type_id === 1) {
                      slots.push(result);
                    }
                  }
                }
                t.lessons.forEach(l => {
                  const index = t.study_center_skills.findIndex(
                    sk => sk.id === l.teacher_skill_id
                  );
                  if (l) {
                    l.start_time = l.start;
                    delete l.start;
                    if (l.start_time && l.finish) {
                      lessons.push({
                        skill_name: t.study_center_skills[index]
                          ? t.study_center_skills[index].name
                          : null,
                        split: l.teacher_id,
                        start:
                          l.date.substr(0, 10) +
                          ' ' +
                          l.start_time.substr(0, 5),
                        end: l.date.substr(0, 10) + ' ' + l.finish.substr(0, 5),
                        resizable: true,
                        ...l
                      });
                    }
                  }
                });
              });
              lessons.forEach((lesson, ind) => {
                const index = slots.findIndex(
                  slot => slot.teacher.id === lesson.teacher_id
                );
                const start = index;
                const length = start + slots.length;
                let flag = true;
                for (let i = start; i < length; i++) {
                  if (
                    slots[i] &&
                    slots[i].slot &&
                    slots[i].slot.start === lesson.start_time &&
                    slots[i].slot.finish === lesson.finish &&
                    slots[i].teacher.id === lesson.teacher_id
                  ) {
                    slots[i].lesson = lesson;
                    flag = false;
                  }
                }
                if (flag) {
                  const slot = {
                    ...lesson,
                    resizable: true,
                    lesson
                  };
                  const slotFind = slots.findIndex(el => el.id === slot.id);
                  const teacher = state.teachers.find(
                    item => item.id === +lesson.split
                  );
                  if (teacher && slotFind === -1) {
                    slot.teacher = teacher;
                    slots.push(slot);
                  }
                }
              });
            });

            //
            // // commit('CHANGE_CAMPUS', day);
            commit('CHANGE_CAMPUS_LESSONS', slots);
            commit('CHANGE_CAMPUS_LOADING');
          });
      }
    }
  }
};
